import { render, staticRenderFns } from "./lawoffsuccase.vue?vue&type=template&id=1f37818e&scoped=true&"
import script from "./lawoffsuccase.vue?vue&type=script&lang=js&"
export * from "./lawoffsuccase.vue?vue&type=script&lang=js&"
import style0 from "./lawoffsuccase.vue?vue&type=style&index=0&id=1f37818e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f37818e",
  null
  
)

export default component.exports